// extracted by mini-css-extract-plugin
module.exports = {"icon":"OfferBanner_base_icon__1NEFm"};